// Auto generated. Use `npm run icons` to regenerate.

// fab
import {
  faCanadianMapleLeaf as fabCanadianMapleLeaf,
} from "@fortawesome/free-brands-svg-icons";

// fal
import {
  faCircleCheck as falCircleCheck,
} from "@fortawesome/pro-light-svg-icons";

import { library, config } from "@fortawesome/fontawesome-svg-core"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"

// This is important, we are going to let Nuxt worry about the CSS
config.autoAddCss = false

library.add(
  fabCanadianMapleLeaf,
  falCircleCheck
);

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component('fa', FontAwesomeIcon, {})
})
